import { useCallback } from "react";
import { DocumentViewerProvider, useDocumentViewer } from "../context/DocumentViewerContext";
import { DocumentViewer } from "../pages/DocumentViewer";

export function DocumentViewerWrapper({children}){
    return <DocumentViewerProvider>
                    {children}
    </DocumentViewerProvider>
}

export function DocumentRenderer({render,canDownload=false}){
    const {documentState,setDocumentState} = useDocumentViewer();
    const updateDocumentContext = useCallback((newStateChanges)=>{
       setDocumentState(prev=>({...prev,...newStateChanges}));
    },[])
    return <>
    {render(updateDocumentContext)}
   { documentState.open && <DocumentViewer onClose={()=>{
        setDocumentState(prev=>({...prev,open:false}))
    }} reason={documentState.reason} needsApproval={documentState.isApproval} open={documentState.open} documentTitle={documentState.documentTitle} download={documentState.download} documentUrl={documentState.documentViewUrl} onSubmit={documentState.onSubmit} fileStatus={documentState.fileStatus} serverUrl={documentState.documentDownloadUrl} />}
    </>
}